import {useQuery, UseQueryOptions, useMutation, UseQueryResult, UseMutationOptions, UseMutationResult} from 'react-query'
import { APIEndpoints } from '../constants/api-endpoints'
import { QueryKeys }     from './_query_keys'
import { HttpRequest }  from '../services/_http'
import { useState } from 'react'

/* =========================
   GET Icon List
========================= */
// export const useGetIcons = (options?: any) => {
//     return useQuery(
//         ['icons-master'],
//         () =>
//             HttpRequest({
//                 url: `${APIEndpoints.Icons}`,
//                 method: 'GET',
//             }),
//         {
//             ...options,
//         }
//     )
// }


export const useGetIcons = (searchOptions?:any, options?: UseQueryOptions): UseQueryResult <any> => {

    const method   = 'GET'
    const queryKey = [QueryKeys.ICONS,searchOptions]

    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.Icons}`,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus:false,
        cacheTime: 0,
        ...options
    })
}

export const useGetIconData = (searchOptions?: any, options?: UseQueryOptions): UseQueryResult<any> => {

    const method = 'GET'
    const queryKey = [QueryKeys.ICONS, searchOptions]
    /** To keeping old data until response received with new data */
    const [keepPreviousData, setkeepPreviousData] = useState(true)
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: APIEndpoints.Icons,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus: false,
        keepPreviousData,
        onError: () => setkeepPreviousData(false),
        onSuccess: () => setkeepPreviousData(true),
        ...options
    })
}

/* =========================
   ADD Icon
========================= */
export const useAddIcon = (options?: any) => {

    const method = 'POST'

    return useMutation({
        mutationFn: (data: any) =>
            HttpRequest({
                url: `${APIEndpoints.Icons}`,
                data,
                method,
            }),
        ...options,
    })
}

/* =========================
   Update Status Icon
========================= */
export const useStatusIcons = (options?: any) => {
    const method = 'PATCH'
    return useMutation(({data, id}: {data: FormData, id: any})=> HttpRequest({
        url: `${APIEndpoints.Icons}/${id}/status`,
        method,
        data
    }), options)
}


/* =========================
   DELETE Icon
========================= */
export const useDeleteIcons = (
  options?: UseMutationOptions<any, any, any>
): UseMutationResult<any, any, any> => {

  const method = 'DELETE'

  return useMutation({
    mutationFn: ({ id }: { id: number }) =>
      HttpRequest({
        url: `${APIEndpoints.Icons}/${id}`,
        method,
      }),
    ...options,
  })
}